exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3TrbIfV5oy3d3PzKLfN_cq{background:#ebebeb;padding:10px;font-family:\"aktiv-grotesk\",\"Aktiv Grotesk\",\"Open Sans\",\"Gill Sans MT\",\"Gill Sans\",Corbel,Arial,sans-serif;position:relative}._3CXx0jT9p8aNEfJQtCh6yT{display:flex;margin:40px 0}._3ArR2keUJxTOIHljqEhhfA{flex:1;text-align:center;font-size:16px;cursor:pointer}._3ArR2keUJxTOIHljqEhhfA i{display:block;margin:0 auto;opacity:0.5;transition:opacity 0.15s ease-in-out}._3ArR2keUJxTOIHljqEhhfA:hover i{opacity:1}.upQAvijCICppKWwEnTpMO{background:#23abca;text-align:center;display:flex;align-items:center}\n", ""]);

// Exports
exports.locals = {
	"MetaBlock": "_3TrbIfV5oy3d3PzKLfN_cq",
	"blockList": "_3CXx0jT9p8aNEfJQtCh6yT",
	"blockItem": "_3ArR2keUJxTOIHljqEhhfA",
	"adminBlocks": "upQAvijCICppKWwEnTpMO"
};